import { render } from "./Featured.vue?vue&type=template&id=dad744c2&scoped=true"
import script from "./Featured.vue?vue&type=script&lang=js"
export * from "./Featured.vue?vue&type=script&lang=js"

import "./Featured.vue?vue&type=style&index=0&id=dad744c2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-dad744c2"

export default script